import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Camera, Upload } from '@phosphor-icons/react';

export function FileUploadSection({ uploadedFiles, onFileUpload }) {
  return (
    <Card className="border-zinc-300 rounded-sm shadow-sm">
      <CardHeader className="border-b border-zinc-300">
        <CardTitle className="text-xl font-bold text-zinc-950">Upload Documents</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-3">
            <Label className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">Scanned Job Order</Label>
            <div className="border-2 border-dashed border-zinc-300 rounded-sm p-8 text-center">
              <input
                type="file"
                id="upload-job-order"
                data-testid="upload-job-order"
                accept="image/*,application/pdf"
                onChange={(e) => onFileUpload(e, 'job_order')}
                className="hidden"
              />
              <label htmlFor="upload-job-order" className="cursor-pointer">
                <Camera size={32} className="mx-auto text-zinc-400 mb-2" />
                <p className="text-sm text-zinc-500">Tap to take photo or select file (Image/PDF)</p>
              </label>
            </div>
          </div>
          <div className="space-y-3">
            <Label className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">Diagram</Label>
            <div className="border-2 border-dashed border-zinc-300 rounded-sm p-8 text-center">
              <input
                type="file"
                id="upload-diagram"
                data-testid="upload-diagram"
                accept="image/*,application/pdf"
                onChange={(e) => onFileUpload(e, 'diagram')}
                className="hidden"
              />
              <label htmlFor="upload-diagram" className="cursor-pointer">
                <Upload size={32} className="mx-auto text-zinc-400 mb-2" />
                <p className="text-sm text-zinc-500">Click to capture or upload (Image/PDF)</p>
              </label>
            </div>
          </div>
        </div>
        {uploadedFiles.length > 0 && (
          <div className="mt-4 space-y-2">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">Uploaded Files:</p>
            {uploadedFiles.map((file, idx) => (
              <div key={`${file.filename}-${idx}`} className="text-sm text-zinc-950 bg-zinc-50 p-2 rounded-sm">
                {file.filename} ({file.file_type})
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
